exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.md-layout-item[data-v-b76b8b44] {\n  padding-top: 10%;\n}\n.md-layout-item label.control-label[data-v-b76b8b44] {\n    display: block;\n    text-align: left;\n    font-size: 1.5rem;\n}\n.md-layout-item input.form-control[data-v-b76b8b44] {\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    width: 100%;\n    font-size: 2rem;\n    padding: 5px 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b76b8b44","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/parts/TextField.vue
// module id = GpDw
// module chunks = 1